import { useEffect, useState } from 'react';

function useTopMenuPlugin(editorReady, editorViewRef) {
  const [menuItems, setMenuItems] = useState([]);

  const plugin =
    editorViewRef.current && editorViewRef.current.pluginViews
      ? editorViewRef.current.pluginViews.find(p => p.name === 'top-menu-plugin')
      : null;

  useEffect(() => {
    if (editorReady) {
      setMenuItems(
        plugin.items.map(item => {
          return { ...item, editorView: plugin.editorView };
        })
      );
    }
  }, [editorReady, plugin && plugin.updatedAt]);

  return {
    menuItems
  };
}

export default useTopMenuPlugin;



// WEBPACK FOOTER //
// ./app/javascript/client/editor-ui/menus/topMenu/useTopMenuPlugin.js